import UserType from 'constants/user';
import { useAuth } from 'contexts/AuthContext';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { useQueryData } from 'hooks/useQuery';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { authenticationActions } from 'redux/authentication/authentication.slice';
import { getMe } from 'redux/authentication/user_detail';
import { PATH } from 'routes/constant';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
import { LOCAL_STORAGE_KEY } from 'utils/constant';
export const useAuthenticate = (
    isLogin: Boolean | undefined,
    userType: any | undefined,
    setLoading: any | Function,
) => {
    const { currentUser } = useAuth();
    const dispatch = useDispatch();
    const history = useHistory();
    const dataConfig = useQueryData(USER_DETAIL, null, currentUser, true);
    useEffect(() => {
        if (dataConfig && dataConfig.dataQuery && currentUser) {
            dispatch(getMe(dataConfig.dataQuery.me));
            dispatch(authenticationActions.setApproved(dataConfig.dataQuery.me.approved));
            setLoading(false);
            if (dataConfig.dataQuery.me && dataConfig.dataQuery.me.userType === UserType.Customer) {
                history.push(PATH.QUIZ_MANAGER);
            } else {
                history.push(PATH.HOME);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataConfig, currentUser]);

    useEffect(() => {
        if (currentUser) {
            dispatch(authenticationActions.setUserId(currentUser.multiFactor.user.uid));
            dispatch(authenticationActions.loginSuccess(true as any));
            if (isLogin) {
                localStorage.setItem('mostRecentNotificationId', '-1');
                const startTime: any = Date.now();
                localStorage.setItem('startTime', startTime);
            }
            setLoading(false);
            // dataConfig();
        } else {
            setLoading(false);
            if (!isLogin && userType) {
                if (userType === UserType.Stylist) {
                    history.push(PATH.SIGNUP_STYLIST);
                } else if (userType === UserType.Customer) {
                    history.push(PATH.SIGNUP_CUSTOMER);
                }
            } else {
                history.push(PATH.LOGIN);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser, dispatch, history, isLogin, userType]);
};

export const loginCallBack = ({ currentUser, dispatch, history, me, setLoading, handleLogout }) => {
    if (currentUser?.multiFactor && currentUser?.multiFactor?.user) {
        dispatch(authenticationActions.setUserId(currentUser?.multiFactor?.user?.uid));
    }
    dispatch(authenticationActions.loginSuccess(true as any));
    localStorage.setItem('mostRecentNotificationId', '-1');
    const startTime: any = Date.now();
    localStorage.setItem('startTime', startTime);
    dispatch(getMe(me));
    dispatch(authenticationActions.setApproved(me.approved));
    setLoading(false);
    if (me) {
        if (me.userType !== UserType.Customer && me.userType !== UserType.Stylist) {
            if (handleLogout) handleLogout({ isAdminAccount: true });
        } else if (me.userType === UserType.Customer) {
            handleGenderMismatchEvent(me);
            history.push(PATH.QUIZ_MANAGER);
        } else {
            history.push(PATH.HOME);
        }
    }
};

export const trackSignupEvent = (params) => {
    trackEvent(TRACK_EVENT.SIGNUP, params);
};

export const handleGenderMismatchEvent = (user) => {
    const localUserStr = localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY);
    const localUser = localUserStr ? JSON.parse(localUserStr) : null;
    if (localUser?.gender && user?.gender && localUser?.gender !== user?.gender) {
        const params = {
            anonymousUserId: localUser.id,
            anonymousUserGender: localUser.gender,
            userId: user?.id,
            userType: user?.userType,
            email: user?.email,
            name: user?.firstName,
            oldGender: localUser?.gender,
            newGender: user?.gender,
        };
        trackEvent(TRACK_EVENT.STYLE_CHAT_GENDER_MISMATCH, params);
    }
};
